/**
 * Règles d'affichage des sièges exiPlan (mode `registre`, lot O3) — fonctions pures, sans réseau.
 *
 * Le serveur reste seul juge (403 `ROLE_INSUFFISANT`, `FACTURATION_SANS_SIEGE`…) : ces gardes ne
 * servent qu'à ne pas proposer un bouton qui ne mènerait qu'à un refus.
 */

/**
 * Qui gère les sièges : `proprietaire`, `administrateur`, `facturation` (D-C). Écrit en extension
 * et non en rang, comme `ROLES_GESTION_SIEGES` (`server/src/middlewares/siege.js`) : `facturation` est classé sous
 * `administrateur` dans `ORG_ROLE_RANK`, `orgRoleAtLeast` l'exclurait à tort de son propre métier.
 * @param {string|undefined} role rôle D3 de l'appelant dans l'organisation
 */
export function peutGererSieges(role) {
  return role === 'proprietaire' || role === 'administrateur' || role === 'facturation';
}

/**
 * Nom à afficher pour un membre : nom du compte exiPlan, sinon adresse (connue des gestionnaires),
 * sinon `null` — l'appelant pose alors son libellé traduit (« Membre sans nom »).
 * @param {{ name?: string|null, email?: string|null }} membre
 * @returns {string|null}
 */
export function nomMembre(membre) {
  return membre?.name || membre?.email || null;
}

/** Un membre du registre peut n'avoir aucun compte exiPlan (`userId` nul, ACC-2). */
export function estMembreSansCompte(membre) {
  return !membre?.userId;
}

/**
 * Membres à qui l'on peut attribuer un siège : actifs, sans siège. Un siège `suspendu` se
 * réactive (409 `SIEGE_SUSPENDU` sinon) ; un membre suspendu ou en demande n'en reçoit pas.
 * @param {Array<{ statut?: string, siege?: string|null }>} membres
 */
export function candidatsSiege(membres) {
  return membres.filter((membre) => membre.statut === 'active' && !membre.siege);
}
